import { useState } from 'react';
import { isEqual } from 'lodash-es';

/**
 * useReducer
 * @param {function} reducer
 * @param {object} initialState
 */
const useReducer = (reducer, initialState) => {
  const [state, setState] = useState(initialState);

  const dispatch = action => {
    const nextState = reducer(state, action);
    if (!isEqual(nextState, state)) {
      setState(nextState);
    }
  };

  return [state, dispatch];
};

export default useReducer;
